import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { GraduationCap, Award } from 'lucide-react';
import { qualifications } from '../data/mock';

const Qualifications = () => {
  return (
    <section id="qualifications" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-amber-600 font-semibold text-lg mb-2">Credentials</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-800 mb-4">
            Professional Qualifications
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive credentials from premier institutions ensuring excellence in service delivery
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {qualifications.map((qual) => (
            <Card
              key={qual.id}
              className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-none bg-gradient-to-br from-slate-50 to-gray-100"
            >
              <CardContent className="pt-6">
                <div className="flex justify-center mb-4">
                  <div className="w-16 h-16 bg-amber-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    {qual.id <= 4 ? (
                      <GraduationCap className="w-8 h-8 text-white" />
                    ) : (
                      <Award className="w-8 h-8 text-white" />
                    )}
                  </div>
                </div>
                <h3 className="text-lg font-bold text-slate-800 text-center mb-3 min-h-[56px] flex items-center justify-center">
                  {qual.title}
                </h3>
                <Badge className="w-full justify-center mb-3 bg-slate-700 hover:bg-slate-800 text-white">
                  {qual.institution}
                </Badge>
                <p className="text-sm text-gray-600 text-center leading-relaxed">
                  {qual.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-lg text-gray-700 max-w-4xl mx-auto">
            With certifications spanning accounting, law, and cutting-edge technology including Block Chain and 
            Artificial Intelligence, I bring a unique blend of traditional expertise and modern innovation to 
            complex financial and tax challenges.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Qualifications;